/** @jsx createElement */
import { Card } from '../svg/card';
import { Person } from '../svg/person';
import { Email } from '../svg/email';
import { Alert } from '../svg/alert';
import { EmailAlert } from '../svg/email-alert';
// Other
import { observer } from 'mobx-react';
import { createElement } from 'react';
import anime from 'animejs';
import { activate, deactivate, shimmer, activateShimmer } from '../helpers';
import { AnimatedSlide } from '../animated-slide';
import { Page061 } from './pages/page-06-1';

@observer
export class Slide28 extends AnimatedSlide {
  // Animation players
  players = {
    alert: null,
  };

  // Run the first animation
  componentDidMount() {
    this.players.border = this.players.alert.querySelector('.border');

    const { alert, border } = this.players;

    this.steps = [
      // Step 3
      () => {},
    ];

    this.animations = [
      //
      // Step 3
      //
      [
        {
          targets: alert,
          easing: 'easeOutQuad',
          opacity: 1,
          duration: 500,
          begin: activateShimmer,
        },
        {
          targets: border,
          opacity: [0, 1],
          strokeDashoffset: [anime.setDashoffset, 0],
          duration: 1000,
          easing: 'easeInOutSine',
        },
      ],
    ];

    // Play the first animation
    this.play();
  }

  render() {
    const { children, className = '' } = this.props;

    return (
      <div className={`slide-28 ${className}`}>
        {children}
        <div className="content">
          {/* Alert */}
          <div
            className="player alert"
            data-active="0"
            ref={node => (this.players.alert = node)}
          >
            <Alert
              color="#54D5AE"
              title={'MESSAGE FROM ESENTIRE'}
              IconComponent={EmailAlert}
              subtitle={'THREAT SUMMARY'}
            />
          </div>
        </div>
      </div>
    );
  }
}
